import styled from 'styled-components'

export const HeadingWrap = styled.div`
display: flex;
align-items: center;
justify-content: center;
`
export const Span = styled.span`
width: fit-content;
display: flex;
align-items: center; 
justify-content: center;
font-size: 25px;
font-weight: 600;
border: 0.5px solid black;
padding:  5px;
padding-left: 15px;
padding-right: 15px;
border-radius: 16px;
margin: 20px 0;
background-color: #95def6;
-webkit-box-shadow: 4px 7px 9px 1px rgba(0,0,0,0.75);
-moz-box-shadow: 4px 7px 9px 1px rgba(0,0,0,0.75);
box-shadow: 4px 7px 9px 1px rgba(0,0,0,0.75);
`
export const BackButtonSpan = styled.span`
display: flex;
align-items: center;
justify-content: center;
position: relative;
box-sizing: border-box;
cursor: pointer;
font-family: "Roboto","Helvetica","Arial",sans-serif;
font-weight: 600;
font-size: 0.75rem;
line-height: 1.75;
letter-spacing: 0.02857em;
text-transform: uppercase;
min-width: 64px;
height: 40px;
padding: 6px 16px;
border-radius: 4px;
border-width: 0;
transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
color: #ebe6e6;
background-color: #067f69;
box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
margin: 8px;
`
export const CommonButton = styled.button`
display: flex;
align-items: center;
justify-content: center;
/* box-sizing: border-box; */
cursor: pointer;
font-family: "Roboto","Helvetica","Arial",sans-serif;
font-weight: 600;
font-size: 0.75rem;
line-height: 1.75;
letter-spacing: 0.02857em;
text-transform: uppercase;
min-width: 64px;
height: 40px;
padding: 6px 16px;
border-radius: 4px;
border-width: 0;
color: #ebe6e6;
background-color: #008080;
box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
margin: 8px;
`

export const AddRemarkButton = styled.button`
display: flex;
align-items: center;
justify-content: center;
position: relative;
box-sizing: border-box;
cursor: pointer;
font-family: "Roboto","Helvetica","Arial",sans-serif;
font-weight: 600;
font-size: 0.75rem;
line-height: 1.75;
letter-spacing: 0.02857em;
text-transform: uppercase;
min-width: 64px;
height: 40px;
padding: 6px 16px;
border-radius: 4px;
border-width: 0;
transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
color: #ebe6e6;
background-color: #893ca3;
box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
margin: 8px;`

export const PopupButton = styled(CommonButton)`
background-color: #2E5894;
padding-top: 5px;
padding-bottom: 5px;
`

export const PreDataWrap = styled.div`
margin-top: 25px;
margin-bottom: 25px;
background-color: #aaf7e6;
border: solid black 1px;
border-radius: 16px;
padding: 15px;
`
export const ReqWrapper = styled.div`
background-color:  #cfeef3;
border-radius: 16px;
`
export const IntReqWrapper = styled.div`
background-color:  #cfeef3;
`
export const ExtReqWrapper = styled.div``

export const RequestClosureWarapperAccepted = styled.div`
font-size: 25px;
border: solid black 1px;
border-radius: 16px;
padding: 15px;
background-color: #008080;
`
export const RequestClosureWarapperRejected = styled.div`
font-size: 25px;
border: solid black 1px;
border-radius: 16px;
padding: 15px;
background-color: #fa4848;
`
export const StoreNameCont = styled.div`
display: flex;
align-items: center;
justify-content: center;
`

// {HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, RequestClosureWarapperAccepted,RequestClosureWarapperRejected, AddRemarkButton,BackButtonSpan, ReqWrapper, StoreNameCont, ExtReqWrapper, PopupButton  }